import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {WebMetricEventDirective} from './web-metric-event.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    WebMetricEventDirective
  ],
  exports: [
    WebMetricEventDirective
  ],
  providers: []
})
export class WebMetricsModule {
}
